module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-vault-1.42857efb.svg";